import { Select, SelectProps } from '@sgi/gravity';
import { useControl } from '../../hooks/useControl';

export type FormSelectProps = Omit<SelectProps, 'error' | 'value' | 'onBlur' | 'options'>;
export const FormSelect = (props: FormSelectProps) => {
  const { error, field } = useControl({ name: props.name });

  return (
    <Select
      {...props}
      error={error}
      {...field}
      onChange={e => {
        props.onChange?.(e);
        field.onChange(e);
      }}
    />
  );
};
